/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { ClientCifsShareService } from '../../cifs-share/client-cifs-share/client-cifs-share.service';
import { DataTurboShareService } from '../data-turbo-share.service';
import { DataTurboShareStrService } from '../data-turbo-share-str.service';
import { CopyFromDataTurboShareComponent } from './copy-from-data-turbo-share.component';

@NgModule({
    declarations: [CopyFromDataTurboShareComponent],
    exports: [CopyFromDataTurboShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        DataTurboShareStrService,
        DataTurboShareService,
        ClientCifsShareService,
    ],
})
export class CopyFromDataTurboShareModule { }
